import { useMemo } from 'react';
import {
  DisplayModeContext,
  DisplayModeContextType,
} from './DisplayModeContext';
import { useDisplayModeContext } from './useDisplayModeContext.hook';

interface SideMenuCompactProviderProps {
  children: React.ReactNode;
}

/**
 * Provides a display mode context scoped to the side menu that always uses 'compact' layout.
 * Use this to keep the side menu slim while other parts of the app can use the global displayMode.
 */
export const SideMenuCompactProvider = ({
  children,
}: SideMenuCompactProviderProps) => {
  const parentContext = useDisplayModeContext();

  const value: DisplayModeContextType = useMemo(
    () => ({
      ...parentContext,
      displayMode: 'compact',
    }),
    [parentContext]
  );

  return (
    <DisplayModeContext.Provider value={value}>
      {children}
    </DisplayModeContext.Provider>
  );
};
